import { initializeApp, getApps } from 'firebase/app'

import firebaseConfig from './firebaseConfig'

const firebaseApps = getApps()

const firebaseApp = firebaseApps.length
  ? firebaseApps[0]
  : initializeApp(firebaseConfig)

export default firebaseApp
